import { OverlayView, OverlayViewProps } from "@react-google-maps/api"
import React from "react"

export interface CustomMarkerProps
  extends Omit<OverlayViewProps, "mapPaneName"> {
  /**
   * These two properties are used to properly align the overlay content with the the co-ordinate (lat lng)
   * Because the content is usually aligned at the `Bottom Right` corner of the point which makes it look
   * improperly aligned, to solve this use settings like
   * for a div of size 60px x 60px
   * set `top = -30px`
   *     `left = -30px`
   *
   */
  top?: string
  left?: string
  /**
   * A literal containing properties for both latitude and longitude
   */
  position: any

  /**
   * A handful of properties which may be required in the future
   * Feel free to extend these
   */
  style?: React.CSSProperties | undefined
  className?: string
  onClick?: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => void | undefined
}

const CustomMarker = ({
  children,
  top,
  left,
  position,
  style,
  className,
  onClick,
  ...props
}: CustomMarkerProps) => {
  return (
    <OverlayView
      position={position}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      {...props}
    >
      <div
        className={className}
        onClick={onClick}
        style={{
          ...style,
          // This is set by default in order for top and left to take effect
          position: "absolute",
          top,
          left,
        }}
      >
        {children}
      </div>
    </OverlayView>
  )
}

export default CustomMarker
